import { Modal } from "antd";
import { TEditMilestone } from "components/workflow-template-editor/model";

function DeleteConfirmModel({
  setOpen,
  milestone,
  onConfirm
}: {
  milestone: TEditMilestone;
  setOpen: React.Dispatch<React.SetStateAction<TEditMilestone | undefined>>;
  onConfirm: (milestoneId: string) => void;
}) {
  const handleOk = () => {
    onConfirm(milestone.id);
    setOpen(undefined);
  };

  const handleCancel = () => {
    setOpen(undefined);
  };

  return (
    <Modal
      title="DELETE MILESTONE"
      open={!!milestone}
      onOk={handleOk}
      onCancel={handleCancel}
      // antd v6 changed the button class list (exact `ant-btn ant-btn-primary`
      // no longer matches), so give the "Yes" confirm button a class-independent
      // data-testid for UI automation.
      okButtonProps={{
        className: "w-24",
        "data-testid": "delete-confirm-yes-button"
      }}
      cancelButtonProps={{ className: "w-24" }}
      okText="Yes"
      cancelText="Cancel"
      width={450}
      className="workflow-template-editor"
      data-testid="index-modal-delete-confirm"
    >
      <div className="w-full flex-col ">
        <p>
          Are you sure you want to delete
          <strong className="px-1">{milestone.name} ?</strong>
          Deleting the milestone will also delete the associated duration,
          present after the milestone.
        </p>

        <div className="font-medium py-1">
          Are you sure you want to proceed?
        </div>
      </div>
    </Modal>
  );
}

export default DeleteConfirmModel;
